<template>
  <div class="page pathway-screen">
    <VideoControl
      v-if="pathway.animation"
      ref="pathwayContentControl"
      :source="animation"
      :alarm="alarm"
      @onAlarm="onAlarm"
      @onEnded="onEnded"
    />
    <Transition>
      <component
        v-if="section"
        :key="section.index"
        :is="section.type"
        :section="section"
        :idx="`p_${pathway.index}_${section.index}`"
        @action="onAction"
      />
    </Transition>
    <Transition>
      <component
        v-if="timedContent"
        :key="timedContent.index"
        :is="timedContent.type"
        :section="timedContent"
        :idx="`t_${pathway.index}_${timedContent.index}`"
        @action="onAction"
      />
    </Transition>

    <div
      :class="[ 'button', 'button-navigation', 'button-next', { active: nextButtonState } ]"
      @click.prevent="next"
    ></div>
  </div>
</template>

<script>
import ContentSection from '../sections/ContentSection.vue'
import PathwayDetail from '../sections/PathwayDetail.vue'
import RolloverSection from '../sections/RolloverSection.vue'
import VideoControl from '../partials/VideoControl.vue'

export default {
  name: 'PathwayScreen',
  components: {
    ContentSection,
    PathwayDetail,
    RolloverSection,
    VideoControl,
  },
  props: {
    pathway: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      alarm: null,
      alarmState: -1,
      section: null,
      sectionIndex: -1,
      timedContent: null,
      timedIndex: -1,
      paused: false,
      nextButtonState: false,
      complete: false,

      alarmStateHandlers: {
        'start': this.showTimedContent,
        'end': this.hideTimedContent,
      },
      eventHandlers: {
        'playChapter': this.playChapter,
        'activateButton': this.activateButton,
        'setNextButtonState': this.setNextButtonState,
        'setNextAlarm': this.setNextAlarm,
        'next': this.next,
      },
    }
  },
  computed: {
    animation() {
      return this.$store.getters.video(this.pathway.animation);
    },
  },
  methods: {
    onAction(event) {
      if (event.type in this.eventHandlers) {
        this.eventHandlers[event.type](event);
      } else {
        this.$emit('action', event);
      }
    },
    
    playChapter(event) {
      this.$refs['pathwayContentControl'].playChapter(event.data.chapter);
      this.onEndedCallback = event.data.onEnded || null;
    },
    activateButton() {
      if (this.section.autoplay) {
        this.nextSection();
      } else {
        this.nextButtonState = true;
      }
    },
    setNextButtonState(event) {
      this.nextButtonState = event.data;
    },
    next() {
      this.nextSection();
      if (this.section.chapter !== null) {
        this.nextButtonState = false;
      }
    },

    pause() {
      this.$refs['pathwayContentControl'].pause();
      this.paused = true;
    },
    resume() {
      this.$refs['pathwayContentControl'].resume();
      this.paused = false;
    },

    nextSection() {
      if (this.sectionIndex + 1 < this.pathway.sections.length) {
        this.sectionIndex += 1;
        this.section = this.pathway.sections[this.sectionIndex];
      } else {
        this.$emit('action', { type: 'clearPathway' });
      }
    },
    setNextAlarm(event) {
      this.timedIndex = -1;
      this.pathway.timed.forEach((item, index) => {
        if (item.chapter.start >= event.data.start && item.chapter.end <= event.data.end) {
          this.timedIndex = index;
          return;
        }
      });

      if (this.timedIndex > -1) {
        this.alarm = this.pathway.timed[this.timedIndex];
      } else {
        this.alarm = null;
      }
    },
    setTimedContent() {
      const item = this.pathway.timed[this.timedIndex];
      if (item.pause === 0) { this.pause(); }
      this.timedContent = item;
    },
    
    onAlarm(alarmState) {
      if (alarmState === 'start') {
        this.setTimedContent();
      } else {
        if (this.timedContent.pause === 1) { this.pause(); }
        this.timedContent = null;
      }
    },
    onEnded() {
      if (this.onEndedCallback) {
        this.onEndedCallback();
      }
    },
  },
  mounted() {
    this.$emit('action', { type: 'writeAnalytics', data: this.pathway.label });
    this.$store.commit('SetReferenceGroup', this.pathway.references);
    setTimeout(() => this.nextSection(), 500);
  },
  beforeUnmount() {
    this.$store.commit('SetReferenceGroup', 0);
  },
}
</script>
